let chalk = require('chalk');

const SKIP  = "skip";
const SPAN = "span";
const APPEND = 16;







export default function parseLatex(string){


  /*
  let styleToIndex = { 
    color:{
      red:[0,2],
      green:[[3,8]],
      blue:[[8,12]]
    },
    "font-weight":{
      bold:[2,5]
    },
    "font-style":{
      italic:[7,10]
    },
    "font-size":{
      32:[0,2]
    }
  }
  */

  let styleToIndex = {};

  let baselineRanges = { sup:[], sub:[] }
  let curBaseline = []; 

  for(let ii = 0; ii < string.length; ii++){

    let char = string[ii];
    if( char === '{' && string[ii+1] === '}' ){
      curBaseline.push(ii);
      //curBaseline.push(ii+1);
      //ii++;
    }else if( char === '^' && string[ii+1] === '{' ){
      let k = 0;
      curBaseline = [ii+2];
      baselineRanges.sup.push(curBaseline);
    }else if( char === '_' && string[ii+1] === '{' ){
      curBaseline = [ii+2];
      baselineRanges.sub.push(curBaseline);
    }else if( char === '}' ){

      //console.log("GOT END OF BRACKET, ii = " + ii);
      console.dir({curBaseline},{depth:null});
      if( curBaseline ){
        curBaseline.push(ii);
      }
      curBaseline = [];
      
      //console.log(baselineRanges);
    }
  }

  //console.log(baselineRanges);
  //process.exit(0);


  let actionsByIndex = [];

  Object.entries(styleToIndex).forEach(([prop,vals]) => {
    Object.entries(vals).forEach(([value,range]) => {

      let [ start, end ] = range;
      let startAction = actionsByIndex[start]
      if( !startAction ){
        actionsByIndex[start] = { s:{ [prop]:value }, e:{} }
      }else{
        startAction.s[prop] = value;
      }

      let endAction = actionsByIndex[end];
      //console.log("END ACTION --> ");
      //console.log(endAction);
      if( !endAction ){
        actionsByIndex[end] = { s:{}, e:{ [prop]:value } }
      }else{

        endAction.e[prop] = value;
      }
    })
  })


  let baselineTags = ["sup","sub"];
  baselineTags.forEach(tag => {
    baselineRanges[tag].forEach(range => {

      let [s,e] = range;

      let caret = actionsByIndex[s-2];
      if( !caret ){
        actionsByIndex[s-2] = { s:{}, e:{}, skip:true }
      }else{
        caret.skip = true;
      }
      let openBracket = actionsByIndex[s-1];
      if( !openBracket ){
        actionsByIndex[s-1] = { s:{}, e:{}, skip:true }
      }else{
        openBracket.skip = true;
      }

      //actionsByIndex[s-1] = SKIP;

      //start
      let curStart = actionsByIndex[s];
      if( curStart ){
        curStart.s.tags = [tag]
      }else{
        actionsByIndex[s] = { s:{tags:[tag]}, e:{} }
      }

      //end
      let curEnd = actionsByIndex[e];
      if( curEnd ){
        curEnd.e.tags = [tag];
        curEnd.skip = true;
      }else{
        actionsByIndex[e] = { s:{}, e:{tags:[tag]}, skip:true}
      }
    })
  })

  //actionsByIndex.forEach(a => console.log(a));
  //console.log(actionsByIndex,{depth:null});
  //process.exit(0);




  let stack = [ container({tag:"div"}) ];

  function container(args){
    return {
      ...args,
      c:[...(args.c||[])],
      style:(args.style||{}),
    }
  }

  const pop = () => {
    //console.log(chalk.red.bold("popping"));
    stack.pop();
  }
  const peek = () => {
    return stack[ stack.length - 1 ]
  }
  const topTag = () => peek().tag;

  for(let ii = 0; ii < string.length; ii++){

    let action = actionsByIndex[ii];



    //console.log("---------------");
    //console.log("ii = " + ii + ", char = " + string[ii]+", action = " + chalk.bold.blue(JSON.stringify(action)));
    //console.log(action);
    if( action === SKIP ){
      continue;
    }else{ 

      if( !action ){

        //console.log("peek = " + JSON.stringify(peek()));
        peek().c.push( string[ii] )
        continue;
      }


      //console.log("ACTION = " + chalk.magenta.bold(JSON.stringify(action)));
      let { e, s } = action;
      let startTags = s.tags;
      let endTags = e.tags;




      /*
     when do we need to end span?
      --> for sure if a tag ends and there's an open span
      --> then we need to end.
      I suppose if there's no open span, then we CAN'T end
      And we really only will be starting a new span
      if there are stylistic end/start...
      */
      //pop off all tags
      if( endTags && endTags.length > 0 ){
        endTags.forEach(tag => {

          while( topTag() === SPAN ){

            pop();
          }

          //console.dir({stack},{depth:null});

          if( topTag() !== tag ){
            throw Error(`Weird tag end order. Expected ${tag}, got ${topTag()}`);
          }
        })



        if( endTags[0].tag === "span" ){
          pop();
        }

        ///end current span
        endTags.forEach(pop);
      }
      //createNewStyle from previous 
      //

      let newStyle = {...peek().style};

      //remove style props that are ending
      //console.log("Ending: " + JSON.stringify(e));

      let endStyleEntries = Object.entries(e);
      let startStyleEntries = Object.entries(s);

      endStyleEntries.forEach(([prop,val]) => {

        //console.log(peek());
        while( peek().style[prop] === val ){
          pop();
          //console.log("after pop");
          //console.log(peek());
        }

        delete newStyle[prop];
      })

      startStyleEntries.forEach(([prop,val]) => {
        newStyle[prop] = val;
      })

      if( startTags && startTags.length > 0 ){

        let newTagContainer = container({
          tag:startTags[0],
          c:[],
          style:{}
        });

        peek().c.push(newTagContainer);
        stack.push(newTagContainer);

      }

      let newContainer = container({
        tag:"span",
        c:[],
        style:newStyle
      })

      if( !action.skip ){
        newContainer.c.push(string[ii])
      }


      if( !peek() ){
        debugger;
      }

      peek().c.push( newContainer );
      stack.push(newContainer);

      //console.log("Stack: " + JSON.stringify(stack));

    }
  }

  //console.dir(Object.entries(baselineRanges),{depth:null});
  //console.log

  let toReturn =  (Object.fromEntries(Object.entries(actionsByIndex).map(([key,val]) => {
    return [key,{...val, trace:string[key] }]
  })));

  
  
  return toReturn;



  return {
    actionsByIndex, 
    baselineRanges
  };
}

//console.log(parseLatex("MY NAME IS JONAH I LOVE LAB FIGURES"))


